<template>
  <div class="section">
    <div class="job-header">
      <h1 class="is-size-3 has-text-primary">Jobs created by you</h1>
      <div class="job-header-button">
        <p class="has-text-secondary" v-if="!user.profile.profile_saved">
          Complete your profile to create new jobs!
        </p>
        <div v-else class="button-wrapper">
          <router-link :to="{name: 'job-new'}" class="button is-primary">
            Create new job
          </router-link>
        </div>
      </div>
    </div>
    <JobsTable :query="query"
      @pageChange="this.$router.push({ query: { ...this.$route.query, offset: 10 * (p - 1) } })" />
  </div>
</template>
<script>
import JobsTable from '@/components/Tables/JobsTable';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    query() {
      return {
        order: '-created', employer: this.user.id, limit: 10, ...this.$route.query,
      };
    },
  },
  components: {
    JobsTable,
  },
};
</script>

<style lang="scss" scoped>
.job-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.job-header-button {
  display: flex;
  flex-direction: column;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
